import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { useToast } from '@/components/ui/use-toast';
import { useDeleteSynonym } from 'shared/hooks/search-synonyms.hooks';

// No shadcn AlertDialog exists in this project — a plain Dialog with a
// destructive confirm button is the established pattern for confirmations.
export function DeleteSynonymDialog({ record, onOpenChange, onSuccess }) {
  const { toast } = useToast();
  const deleteSynonym = useDeleteSynonym();

  const onConfirm = async () => {
    try {
      await deleteSynonym.mutateAsync({ id: record.id });
      toast({ title: 'Mapping deleted' });
      onSuccess?.();
      onOpenChange(false);
    } catch (err) {
      toast({
        title: 'Failed to delete mapping',
        description: err?.response?.data?.message || err?.message || 'Unexpected error',
        variant: 'destructive',
      });
    }
  };

  return (
    <Dialog open={!!record} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Delete synonym mapping?</DialogTitle>
          <DialogDescription>
            This permanently removes the mapping — there is no undo. The action is recorded in the
            audit log.
          </DialogDescription>
        </DialogHeader>
        {record && (
          <div className="rounded-md border bg-muted/40 p-3 text-sm">
            <span className="font-medium capitalize">{record.mappingType}</span>
            {': '}
            {record.synonyms?.join(', ')}
          </div>
        )}
        <DialogFooter>
          <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button variant="destructive" loading={deleteSynonym.isPending} onClick={onConfirm}>
            Delete
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
